import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Grid, Typography } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import { AppState } from "../../../redux";
import { getOrganizations } from "../../../redux/organization/actions";
import Loader from "../../../components/theming/loader/Loader";
import UserOrganizationList from "../../../components/core/profile-settings/organization/UserOrganizationList";
import CrudOrganization from "../../../components/core/profile-settings/organization/CrudOrganization";
import CompanyHeading from "../../../components/theming/CompanyHeading";

/**
 * Component for managing organization details and memberships.
 * @returns JSX.Element
 */
export const OrganizationOverviewPage = () => {
  const { t } = useTranslation(["organization", "snackbars"]);
  const organizations = useSelector((state: AppState) => state.organizations);
  const dispatch = useDispatch();
  const [createMode, setCreateMode] = useState(false);

  useEffect(() => {
    if (!organizations.isLoading && !organizations.organizationDataLoaded) {
      dispatch(getOrganizations());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizations.isLoading, organizations.organizationDataLoaded]);

  return (
    <>
      <CompanyHeading>{t("organizations", { ns: "organization" })}</CompanyHeading>
      {!createMode && (
        <>
          <Typography style={{ marginTop: "2rem", marginBottom: "2rem" }}>
            {t("organizationsDesc", { ns: "organization" })}
          </Typography>

          {organizations?.isLoading ? (
            <Loader />
          ) : organizations?.organizationData?.length > 0 ? (
            <UserOrganizationList />
          ) : null}
        </>
      )}

      <Grid
        container
        spacing={3}
        alignItems="center"
        style={{
          display: "flex",
          justifyContent: !createMode ? "space-between" : "flex-end",
        }}
      >
        {!createMode ? (
          <>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ display: "flex", textAlign: "center" }}
            >
              {!organizations?.isLoading &&
              organizations?.organizationData?.length === 0 ? (
                <Typography>{t("noOrganization", { ns: "organization" })}</Typography>
              ) : null}
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                id="addOrganization"
                size="large"
                variant="contained"
                color="primary"
                fullWidth
                onClick={() => {
                  setCreateMode(true);
                }}
              >
                {t("crud.addOrganization", { ns: "organization" })}
              </Button>
            </Grid>
          </>
        ) : (
          <Grid item xs={12} sm={6} md={3}>
            <Button
              id="cancel-add-organization"
              size="large"
              variant="outlined"
              color="primary"
              fullWidth
              onClick={() => {
                setCreateMode(false);
              }}
            >
              {t("forms.buttons.cancel", { ns: "common" })}
            </Button>
          </Grid>
        )}
      </Grid>
      {createMode ? <CrudOrganization /> : null}
    </>
  );
};
